import currency from "currency.js";

/**
 * Singleton currency instance configured with BudgeterConfig settings.
 * Use this instead of importing currency directly to ensure consistent
 * decimal and separator formatting across the application.
 */
export const appCurrency = (
  value: currency.Any,
  opts?: currency.Options
): currency => {
  return currency(value, {
    decimal: window.BudgeterConfig.decimal,
    separator: window.BudgeterConfig.group,
    symbol: "",
    ...opts,
  });
};
